import Axios from "axios";
import * as serviceURL from "./service-url";

export const getTabRakBeneficiaryList = (request, id) => {
  return Axios.post(serviceURL.getTabRakBeneficiaryList + id, request);
};
export const getTabC3BeneficiaryList = (request, id) => {
  return Axios.post(serviceURL.getTabC3toC3BeneficiaryList + id, request);
};
export const deleteUser = (beneficiaryid) => {
  return Axios.delete(serviceURL.deleteUser + beneficiaryid);
};
export const deleteMobileRecharge = (beneficiaryid) => {
  return Axios.delete(serviceURL.deleteMobileRecharge + beneficiaryid);
};
export const getTabBankDetailsList = (id) => {
  return Axios.get(serviceURL.getTabBankDetailsList + id);
};

//
export const getTabRakTransactionsList = (request, id) => {
  return Axios.post(serviceURL.getTabRakTransactionsList + id, request);
};

export const getRakTransactionReceiptById = (transactionId) => {
  return Axios.get(serviceURL.getRakTransactionReceiptById + transactionId);
};
export const getTabC3TransactionList = (request, id) => {
  return Axios.post(serviceURL.getTabC3toC3TransactionList + id, request);
};

//
export const getTabRechargeBeneficiaryList = (request, id) => {
  return Axios.post(serviceURL.getTabRechargeBeneficiaryList + id, request);
};

//
export const getTabRechargeTransactionsList = (request, id) => {
  return Axios.post(serviceURL.getTabRechargeTransactionsList + id, request);
};

export const getTabRechargeTransactionsDetails = (transactionId) => {
  return Axios.get(
    serviceURL.getTabRechargeTransactionsDetails + transactionId
  );
};

//subscription api
export const getSubscriptionDetails = (userId) => {
  return Axios.get(serviceURL.getSubscriptionDetails + userId);
};
// Biller api

export const getBillerList = (request, id) => {
  return Axios.post(serviceURL.getBillerList + id, request);
};
export const deleteBillerList = (billerid) => {
  return Axios.delete(serviceURL.deleteBillerList + billerid);
};
export const getCountryList = (type) => {
  return Axios.get(serviceURL.getCountry + type);
};

// Bill payments
export const getBillpayementList = (request, id) => {
  return Axios.post(serviceURL.getBillpayementList + id, request);
};
//creation history
export const getCreationHistory = (userId, id) => {
  return Axios.get(serviceURL.getCreationHistory + userId, id);
};
